import { atom } from "jotai";

export const ledgerPageAtom = atom(1);
export const ledgerPageSizeAtom = atom(10);
